<template>
<div class=" pt-2 mt-2">
    <div v-if="activeTab==='landingTable'">
        <v-toolbar flat color="white">
            <v-autocomplete ref="selectedStockType" v-on:blur="$refs['selectedStockType'].blur()" pt-5 mt-5 label="Filter By Stock Type" v-model="selectedStockType" :items="stocktypes" item-text="name" item-value="id" clearable></v-autocomplete>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" prepend-inner-icon="search" v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                search: search
                }
                })" label="Search"></v-text-field>
        </v-toolbar>
        <v-data-table :loading="tableloading" :items="tableData" :headers="headers" style="cursor: pointer" :rows-per-page-items="[25, 50, 100, 250]">
            <template v-slot:items="props">
                <td class="text-xs-center" @click="viewItem(props.item)">{{props.item.stockItem.stockType.name}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)">{{props.item.stockItem.name}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)">{{props.item.quantity}}</td>
            </template>
        </v-data-table>
    </div>
    <div v-if="activeTab==='warehouseBreakdown'">
        <v-toolbar flat color="white">
            <h3 class="grey--text">{{item.stockItem.name}}</h3>
            <v-spacer></v-spacer>
            <v-btn flat @click="closeView()">X</v-btn>
        </v-toolbar>
        <v-layout align-top justify-center>
            <v-flex xs3>
                <linechart v-if="loaded" :chartdata="totalStock" :options="totalStockOptions"></linechart>
            </v-flex>
            <v-flex xs3>
                <barchart v-if="loaded" :chartdata="stockMovement" :options="stockMovementOptions"></barchart>
            </v-flex>
            <v-flex xs3>
                <barchart v-if="supplierDataLoaded" :chartdata="stockOrderHistory" :options="stockOrderHistoryOptions"></barchart>
            </v-flex>
            <v-flex xs3>
                <linechart v-if="supplierDataLoaded" :chartdata="priceMovement" :options="priceMovementOptions"></linechart>
            </v-flex>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs3 mx-2>
                <v-card hover>
                    <v-toolbar flat color="white">
                        <h3 class="title grey--text">Stock Locations:</h3>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="transferStock()">
                            <v-icon>input</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <!-- <v-divider></v-divider> -->
                    <v-card-text>
                        <v-list>
                            <v-list-tile v-for="warehouseItem in wareHouseItems" :key="warehouseItem.id">
                                <v-list-item-action>
                                    <v-chip>{{warehouseItem.quantity}}</v-chip>
                                </v-list-item-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="fontSize: 16px">
                                        {{warehouseItem.stockWarehouse.name}}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-item-action>
                                    <v-icon color="grey" @click="checkOutItem(warehouseItem)">forward</v-icon>
                                </v-list-item-action>
                            </v-list-tile>
                        </v-list>
                        <!-- <v-flex xs12 v-for="warehouseItem in wareHouseItems" :key="warehouseItem.id">
                            <v-layout my-1>
                                <v-flex xs6>
                                    <h3 class="grey--text">{{warehouseItem.stockWarehouse.name}}</h3>
                                </v-flex>
                                <v-flex xs4>
                                    <h3 class="grey--text font-weight-light">{{warehouseItem.quantity}}</h3>
                                </v-flex>
                                <v-flex xs2>
                                    <v-icon color="grey" @click="checkOutItem(warehouseItem)">forward</v-icon>
                                </v-flex>
                            </v-layout>
                        </v-flex> -->
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs4 mx-2>
                <v-layout>
                    <v-flex xs12 mx-2>
                        <v-card>
                            <v-toolbar flat color="white">
                                <h3 class="title grey--text font-weight-bold">Movement Log:</h3>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card style="overflow-y: auto; max-height:400px">
                                <v-layout>
                                    <v-flex xs12 mx-2>
                                        <v-list three-line>
                                            <v-list-tile style="border: 1px solid lightgrey" dense v-for="checkout in movementItems" :key="checkout.id" @click="routeToDevice(checkout)">
                                                <div style="width: 100%" v-if="checkout.type =='checkout'">
                                                    <v-list-tile-action v-if="(checkout.checkedIn+checkout.installedCount) < checkout.count">
                                                        <v-chip>{{checkout.count-(checkout.checkedIn+checkout.installedCount)}}</v-chip>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <!-- <v-list-tile-title>
                                                    <span v-if="checkout.device">{{checkout.device.ponMac}}</span>
                                                </v-list-tile-title> -->
                                                        <v-list-tile-title>
                                                            {{checkout.contact.name}} {{checkout.contact.surname}}
                                                        </v-list-tile-title>
                                                        <v-list-tile-subtitle style="font-size: 12px; color: grey">
                                                            {{formatDate(checkout.updatedAt)}}
                                                        </v-list-tile-subtitle>
                                                        <v-layout justify-center style="width: 100%">
                                                            <v-flex xs4 class="text-xs-center">
                                                                <v-icon color="red">arrow_drop_down</v-icon>
                                                                <span>{{checkout.count}}</span>
                                                            </v-flex>
                                                            <v-flex xs4 class="text-xs-center">
                                                                <v-icon color="green">arrow_drop_up</v-icon>
                                                                <span>{{checkout.checkedIn}}</span>
                                                            </v-flex>
                                                            <v-flex xs4 class="text-xs-center">
                                                                <v-icon color="blue">check_circle_outline</v-icon>
                                                                <span class="ml-1">{{checkout.installedCount}}</span>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-list-tile-content>
                                                </div>
                                                <div style="width: 100%" v-else>
                                                    <!-- <v-list-tile-action v-if="(checkout.checkedIn+checkout.installedCount) < checkout.count">
                                                    <v-chip>{{checkout.count-(checkout.checkedIn+checkout.installedCount)}}</v-chip>
                                                </v-list-tile-action> -->
                                                    <v-list-tile-content>
                                                        <!-- <v-list-tile-title>
                                                    <span v-if="checkout.device">{{checkout.device.ponMac}}</span>
                                                </v-list-tile-title> -->
                                                        <v-list-tile-title>
                                                            {{checkout.contact.name}} {{checkout.contact.surname}}
                                                        </v-list-tile-title>
                                                        <v-list-tile-subtitle style="font-size: 12px; color: grey">
                                                            {{formatDate(checkout.updatedAt)}}
                                                        </v-list-tile-subtitle>
                                                        <v-layout style="width: 100%">
                                                            <v-flex xs4 class="text-xs-center">
                                                                <v-icon color="green">arrow_drop_up</v-icon>
                                                                <span>{{checkout.count}}</span>
                                                            </v-flex>
                                                            <!-- <v-flex xs4 class="text-xs-center">
                                                            <v-icon color="green">arrow_drop_up</v-icon>
                                                            <span>0</span>
                                                        </v-flex>
                                                        <v-flex xs4 class="text-xs-center">
                                                            <v-icon color="blue">check_circle_outline</v-icon>
                                                            <span class="ml-1">{{checkout.installedCount}}</span>
                                                        </v-flex> -->
                                                        </v-layout>
                                                    </v-list-tile-content>
                                                </div>

                                            </v-list-tile>
                                        </v-list>
                                        <!-- <v-flex xs12 v-for="checkout in movementItems" :key="checkout.id" my-1>
                              <v-card flat hover style="overflow-y: auto; max-height:400px">
                                <v-layout align-left>
                                  <v-flex xs3><h3 class="grey--text font-weight-light"><v-icon color="red" v-if="checkout.type==='checkout'">arrow_drop_down</v-icon>
                                  <v-icon color="light-green" v-else>arrow_drop_up</v-icon>
                                  {{checkout.count}}</h3></v-flex>
                                  <v-flex xs5><h3 class="grey--text">{{checkout.contact.name}} {{checkout.contact.surname}}</h3></v-flex>
                                  <v-flex xs4><h3 class="grey--text font-weight-light">{{formatDate(checkout.updatedAt)}}</h3></v-flex>
                                </v-layout>
                              </v-card>
                            </v-flex> -->
                                    </v-flex>
                                </v-layout>
                            </v-card>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs5 mx-2>
                <v-layout justify-center>
                    <v-flex xs12 mx-2>
                        <v-card>
                            <v-toolbar flat color="white">
                                <h3 class="title grey--text font-weight-bold">Order History:</h3>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card style="overflow-y: auto; max-height:400px">
                                <v-layout>
                                    <v-flex xs12 mx-2>
                                        <v-layout align-center>
                                            <v-flex xs3>
                                                <h3 class="grey--text">Order Date:</h3>
                                            </v-flex>
                                            <v-flex xs3>
                                                <h3 class="grey--text">Supplier:</h3>
                                            </v-flex>
                                            <v-flex xs2>
                                                <h3 class="grey--text">Quantity:</h3>
                                            </v-flex>
                                            <v-flex xs2>
                                                <h3 class="grey--text">USD Unit Price:</h3>
                                            </v-flex>
                                            <v-flex xs2>
                                                <h3 class="grey--text">ZAR Unit Price:</h3>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>
                                        <v-flex xs12 v-for="order in orderHistory" :key="order.id" my-1>
                                            <v-card flat hover>
                                                <v-layout align-left justify-left>
                                                    <v-flex xs3>
                                                        <h3 class="grey--text font-weight-light">{{formatDate(order.stockOrder.orderDate)}}</h3>
                                                    </v-flex>
                                                    <v-flex xs3 justify-left>
                                                        <h3 class="grey--text font-weight-light">{{order.stockOrder.supplierOrganisation.name}}</h3>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <h3 class="grey--text font-weight-light">{{order.quantity}}</h3>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <h3 class="grey--text font-weight-light">${{order.priceUSD}}</h3>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <h3 class="grey--text font-weight-light">{{order.priceZAR|currency}}</h3>
                                                    </v-flex>
                                                </v-layout>

                                            </v-card>
                                        </v-flex>
                                    </v-flex>
                                </v-layout>
                            </v-card>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-dialog v-model="checkoutItemModal" max-width="500px" persistent>
            <v-card>
                <v-card-text>
                    <h2 class="grey--text">Quantity to Checkout:</h2>
                    <v-text-field type="number" flat outline solo v-model="checkoutQuantity"></v-text-field>
                    <v-card-actions>
                        <v-layout justify-center>
                            <v-btn round class="white--text" color="red" @click="checkoutQuantity=0,checkoutItemModal=false">Cancel</v-btn>
                            <v-btn round class="white--text" v-if="selectedCheckoutItem !==null&&checkoutQuantity<=selectedCheckoutItem.quantity" color="light-green" @click="submitCheckout()">Submit</v-btn>
                            <v-btn v-else disabled round>Submit</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="transferStockModal" width="600px" persistent>
            <v-card>
                <v-toolbar color="primary" flat>
                    <v-toolbar-title style="color: white">Move Inventory</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" flat @click="transferStockModal=false,moveItem={}">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs6 class="text-xs-center">
                            <v-select class="px-2" :items="wareHouseItems" label="Source" item-text="stockWarehouse.name" @change="moveItemKey++" item-value="stockWarehouse.id" return-object v-model="moveItem.sourceStockWarehouse"></v-select>

                        </v-flex>
                        <v-flex xs6 class="text-xs-center">
                            <v-select class="px-2" :items="stockWarehouses" label="Target" item-text="name" @change="moveItemKey++" item-value="id" v-model="moveItem.targetStockWarehouseId"></v-select>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center" v-if="moveItem.sourceStockWarehouse">
                            <span v-if="moveItem.sourceStockWarehouse">Available: <v-chip>{{moveItem.sourceStockWarehouse.quantity}}</v-chip></span>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center" v-if="moveItem.sourceStockWarehouse">
                            <v-text-field v-model="moveItem.quantity" @change="moveItemKey++" label="Quantity"></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn round color="primary" :key="moveItemKey" class="white--text" @click="processMovement()" :disabled="!moveItem.quantity||!(moveItem.quantity<=moveItem.sourceStockWarehouse.quantity)||!moveItem.sourceStockWarehouse||!moveItem.targetStockWarehouseId">Process</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</div>
</template>

<script>
import Api from "@/services/Api";
import Qrcode from 'vue-qrcode';
import dateformat from "dateformat";
import BarChart from './BarChart.vue';
import PieChart from './PieChart.vue';
import LineChart from './LineChart.vue';
import DoughnutChart from './DoughnutChart.vue';
export default {
    props: ['passiveinventory', 'stocktypes', 'tableloading'],
    components: {
        Qrcode,
        barchart: BarChart,
        piechart: PieChart,
        linechart: LineChart,
        doughnutchart: DoughnutChart
    },
    data() {
        return {
            search: '',
            tableData: this.passiveinventory,
            selectedStockType: null,
            item: null,
            wareHouseItems: [],
            checkoutItems: [],
            movementItems: [],
            checkoutItemModal: false,
            checkoutQuantity: 0,
            moveItem: {},
            moveItemKey: 0,
            selectedCheckoutItem: null,
            loaded: false,
            supplierDataLoaded: false,
            totalStock: [],
            totalStockOptions: {},
            stockMovement: [],
            orderHistory: [],
            stockMovementOptions: {},
            stockOrderHistory: [],
            stockOrderHistoryOptions: {},
            priceMovement: [],
            priceMovementOptions: {},
            activeTab: 'landingTable',
            transferStockModal: false,
            stockWarehouses: [],
            headers: [{
                    text: "Type",
                    align: "center",
                    value: "stockItem.stockType.name"
                },
                {
                    text: "Item",
                    align: "center",
                    value: "stockItem.name"
                },
                {
                    text: "Quantity",
                    align: "center",
                    value: "quantity"
                }
            ],
            warehouseHeaders: [{
                    text: "Quantity",
                    align: "center",
                    value: "quantity"
                },
                {
                    text: "Warehouse",
                    align: "center",
                    value: "stockWarehouse.name"
                }
            ]
        }
    },
    // created(){
    //     this.tableData=this.passiveinventory
    // },
    watch: {
        "$route.query.search": {
            immediate: true,
            async handler(value) {
                if (this.$route.query.search && value !== "" && value != null) {
                    await Api()
                        .get("/passiveEquipment", {
                            params: {
                                search: value,
                            },
                        })
                        .then(async (response) => {
                            var helper = {};
                            var result = response.data.reduce(function (r, o) {
                                var key = o.stockItemId;
                                if (!helper[key]) {
                                    helper[key] = Object.assign({}, o);
                                    r.push(helper[key]);
                                } else {
                                    if (o.isActive && !o.isDeleted) {
                                        helper[key].quantity += o.quantity;
                                    }
                                }
                                return r;
                            }, []);
                            console.log(result)
                            this.tableData = result
                        })
                } else if (value === "") {
                    await Api()
                        .get("/passiveEquipment")
                        .then(async (response) => {
                            var helper = {};
                            var result = response.data.reduce(function (r, o) {
                                var key = o.stockItemId;
                                if (!helper[key]) {
                                    helper[key] = Object.assign({}, o);
                                    r.push(helper[key]);
                                } else {
                                    if (o.isActive && !o.isDeleted) {
                                        helper[key].quantity += o.quantity;
                                    }
                                }
                                return r;
                            }, []);
                            console.log(result)
                            this.tableData = result
                        })
                }
            }
        },
        async selectedStockType(value) {
            if (value !== null && typeof value !== 'undefined' && value != '') {
                this.tableData = await this.passiveinventory.filter(function (el) {
                    return el.stockItem.stockTypeId === value
                })
            } else {
                this.tableData = this.passiveinventory
            }
        }
    },
    created() {
        var helper = {};
        var result = this.passiveinventory.reduce(function (r, o) {
            var key = o.stockItemId;
            if (!helper[key]) {
                helper[key] = Object.assign({}, o);
                r.push(helper[key]);
            } else {
                if (o.isActive && !o.isDeleted) {
                    helper[key].quantity += o.quantity;
                }
            }
            return r;
        }, []);
        this.tableData = result
        this.fetchWarehouses()
    },
    methods: {
        fetchWarehouses() {
            Api().get('/stockwarehouse').then(res => {
                this.stockWarehouses = res.data
            })
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd/mm/yyyy HH:MM");
            } else {
                null;
            }
        },
        formatMonth(date) {
            if (date !== null) {
                return dateformat(date, "mm/yyyy");
            } else {
                null;
            }
        },
        async submitCheckout() {
            let stockItemId = this.selectedCheckoutItem.stockItemId
            let stockWarehouseId = this.selectedCheckoutItem.stockWarehouseId
            let fifo = await this.passiveinventory.filter(function (x) {
                return x.stockItemId === stockItemId && x.stockWarehouseId === stockWarehouseId
            })
            if (fifo[0].quantity >= this.checkoutQuantity) {
                Api()
                    .put('/passiveEquipment/' + fifo[0].id, {
                        quantity: fifo[0].quantity - this.checkoutQuantity
                    }).then(response => {
                        let index = this.wareHouseItems.indexOf(this.selectedCheckoutItem)
                        this.wareHouseItems[index].quantity = this.wareHouseItems[index].quantity - this.checkoutQuantity
                    })
            } else {
                let quantity = this.checkoutQuantity
                let array = []
                for (let i = 0; i < fifo.length; i++) {
                    if (quantity > 0) {
                        if (quantity >= fifo[i].quantity) {
                            array.push({
                                id: fifo[i].id,
                                quantity: fifo[i].quantity,
                                index: i
                            })
                            quantity -= fifo[i].quantity
                        } else {
                            array.push({
                                id: fifo[i].id,
                                quantity: quantity,
                                index: i
                            })
                            quantity -= quantity
                        }
                    }
                }
                array.map(x => {
                    Api()
                        .put('/passiveEquipment/' + x.id, {
                            quantity: fifo[x.index].quantity - x.quantity
                        }).then(response => {
                            let index = this.wareHouseItems.indexOf(this.selectedCheckoutItem)
                            this.wareHouseItems[index].quantity = this.wareHouseItems[index].quantity - x.quantity
                        })
                })
            }

            Api()
                .post('/createCheckoutItem', {
                    stockItemId: this.selectedCheckoutItem.stockItemId,
                    stockWarehouseId: this.selectedCheckoutItem.stockWarehouseId,
                    count: this.checkoutQuantity,
                    isActive: true,
                    isDeleted: false
                }).then(response => {
                    this.getStockCheckout(this.selectedCheckoutItem.stockItemId)
                    // this.checkoutItems.push(response.data)
                    this.checkoutQuantity = 0
                    this.checkoutItemModal = false
                    this.selectedCheckoutItem = null
                })
        },
        checkOutItem(item) {
            this.selectedCheckoutItem = item
            this.checkoutItemModal = true
        },
        closeView() {
            this.activeTab = 'landingTable'
            this.item = null
            this.wareHouseItems = []
            this.loaded = false,
                this.supplierDataLoaded = false
            this.totalStock = []
            this.totalStockOptions = {}
            this.stockMovement = []
            this.orderHistory = []
            this.stockMovementOptions = {}
            this.stockOrderHistory = []
            this.stockOrderHistoryOptions = {}
            this.priceMovement = []
            this.priceMovementOptions = {}
        },
        async viewItem(item) {
            this.item = Object.assign({}, item);
            this.getStockCheckout(item.stockItemId)
            this.getStockItemOrderHistory(item.stockItemId)
            let id = item.stockItemId
            let array = await this.passiveinventory.filter(function (el) {
                return el.stockItemId === id
            })
            var helper = {};
            var result = array.reduce(function (r, o) {
                var key = o.stockWarehouseId;
                if (!helper[key]) {
                    helper[key] = Object.assign({}, o);
                    r.push(helper[key]);
                } else {
                    if (o.isActive && !o.isDeleted) {
                        helper[key].quantity += o.quantity;
                    }
                }
                return r;
            }, []);

            this.wareHouseItems = result
            this.activeTab = 'warehouseBreakdown'
        },
        async getStockCheckout(id) {
            var movementItems = []
            await Api()
                .get('/checkoutItem/byStockItem/' + id)
                .then(async response => {
                    // this.checkoutItems = response.data
                    await response.data.map(x => {
                        x.type = 'checkout'
                    })
                    movementItems = response.data
                    // movementItems.forEach(function (element) {
                    //     element.type = "checkout";
                    //   })
                })
            let checkoutItems = []
            await Api()
                .get('/checkinItem/byStockItem/' + id)
                .then(async response => {
                    checkoutItems = response.data.filter(x=>!x.checkoutItemId)
                    await checkoutItems.map(y => {
                        y.type = 'checkin'
                    })
                })
            movementItems = [...movementItems, ...checkoutItems]
            let array = movementItems.sort((a, b) => (a.updatedAt < b.updatedAt) ? 1 : ((b.updatedAt < a.updatedAt) ? -1 : 0));
            this.movementItems = array
            var stockLevels = []
            await array.reverse().map(a => {
                let number = a.count
                if (a.type === 'checkout') {
                    number = number * (-1)
                }
                if (stockLevels.length === 0) {
                    stockLevels.push({
                        date: a.updatedAt,
                        type: a.type,
                        count: number
                    })
                } else {
                    let value = stockLevels[stockLevels.length - 1].count + number
                    stockLevels.push({
                        date: a.updatedAt,
                        type: a.type,
                        count: value
                    })
                }
            })
            let groups = await stockLevels.reduce(function (r, o) {
                var m = o.date.split(('-'))[0] + '-' + o.date.split(('-'))[1];
                (r[m]) ? r[m].data.push(o): r[m] = {
                    group: String(m),
                    data: [o]
                };
                return r;
            }, {});

            var result = await Object.keys(groups).map(function (k) {
                return groups[k];
            });

            await result.map(async b => {
                // b.total = b.data.reduce((a, b) => +a + +b.count, 0)
                let index = await result.indexOf(b)
                if (index === 0) {
                    b.movement = b.data[b.data.length - 1].count - b.data[0].count
                    b.total = b.data[b.data.length - 1].count
                } else {
                    b.movement = b.data[b.data.length - 1].count - result[index - 1].total
                    b.total = b.data[b.data.length - 1].count
                }
            })
            this.initiateGraph(result)
        },
        transferStock() {
            this.transferStockModal = true
        },
        async processMovement() {
            let findExistingRecord = this.wareHouseItems.find(x => x.stockWarehouseId == this.moveItem.targetStockWarehouseId)
            let sourceObject = {
                id: this.moveItem.sourceStockWarehouse.id,
                quantity: this.moveItem.sourceStockWarehouse.quantity - parseInt(this.moveItem.quantity)
            }
            let targetObject = {
                id: null,
                quantity: parseInt(this.moveItem.quantity),
                stockWarehouseId: this.moveItem.targetStockWarehouseId,
                stockItemId: this.item.stockItemId
            }
            if (findExistingRecord) {
                targetObject.id = findExistingRecord.id
                targetObject.quantity += findExistingRecord.quantity
            }

            // Update source
            await Api().put('/passiveEquipment/' + sourceObject.id, sourceObject)

            // Update/Create Target
            if (targetObject.id != null) {
                await Api().put('/passiveEquipment/' + targetObject.id, targetObject)
            } else {
                delete targetObject.id
                await Api().post('/passiveEquipment', targetObject)
            }
            this.transferStockModal = false
            this.moveItem = {}
            this.$emit('refresh')
        },
        initiateGraph(array) {
            this.totalStock = {
                    labels: array.map(x => x.group),
                    datasets: [{
                        label: 'Month',
                        data: array.map(x => x.total),
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 1
                    }]
                },
                this.totalStockOptions = {

                    title: {
                        display: true,
                        text: 'Total Stock'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                },
                this.stockMovement = {
                    labels: array.map(x => x.group),
                    datasets: [{
                        label: 'Movement',
                        data: array.map(x => x.movement),
                        backgroundColor: 'rgba(54, 162, 235, 0.2)',
                        borderColor: 'rgba(54, 162, 235, 1)',
                        borderWidth: 1
                    }]
                },
                this.stockMovementOptions = {

                    title: {
                        display: true,
                        text: 'Total Movements'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }

            this.loaded = true
        },
        async getStockItemOrderHistory(id) {
            await Api()
                .get('/stockOrderItem/byStockItem/' + id)
                .then(async response => {
                    this.orderHistory = response.data.sort((a, b) => (a.orderDate < b.orderDate) ? 1 : ((b.orderDate < a.orderDate) ? -1 : 0));
                    await this.orderHistory.map(async b => {
                        if (b.stockOrder.supplierOrganisation.name.length > 10) {
                            var trimmedString = await b.stockOrder.supplierOrganisation.name.substr(0, 12);
                            trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, b.stockOrder.supplierOrganisation.name.indexOf(" ")))
                            b.stockOrder.supplierOrganisation.name = trimmedString
                        }
                    })
                    let supplierGroup = this.orderHistory.reduce(function (r, o) {
                        var m = o.stockOrder.supplierOrganisationId;
                        (r[m]) ? r[m].data.push(o): r[m] = {
                            supplierOrganisationId: (m),
                            supplierOrganisation: o.stockOrder.supplierOrganisation,
                            data: [o]
                        };
                        return r;
                    }, {});
                    let cost = this.orderHistory.reduce(function (r, o) {
                        var m = o.stockOrder.orderDate.split(('-'))[0] + '-' + o.stockOrder.orderDate.split(('-'))[1];
                        (r[m]) ? r[m].data.push(o): r[m] = {
                            group: String(m),
                            data: [o]
                        };
                        return r;
                    }, {});

                    var supplierResult = Object.keys(supplierGroup).map(function (k) {
                        return supplierGroup[k];
                    });
                    var costResult = Object.keys(cost).map(function (k) {
                        return cost[k];
                    });

                    await supplierResult.map(async b => {
                        //   if(b.supplierOrganisation.name.length > 10){
                        //     var trimmedString = await b.supplierOrganisation.name.substr(0, 12);
                        //     trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, b.supplierOrganisation.name.indexOf(" ")))
                        //     b.supplierOrganisation.name=trimmedString
                        // }
                        b.total = b.data.reduce((a, b) => +a + +b.quantity, 0)
                    })
                    supplierResult.sort((a, b) => (a.total < b.total) ? 1 : ((b.total < a.total) ? -1 : 0));
                    await costResult.map(b => {
                        b.totalPrice = b.data.reduce((a, b) => +a + +b.quantity * b.priceZAR, 0)
                        b.totalUnits = b.data.reduce((a, b) => +a + +b.quantity, 0)
                        b.averagePrice = Math.round((b.totalPrice / b.totalUnits) * 100) / 100
                    })
                    console.log(supplierResult)
                    console.log(costResult)
                    this.initiateSupplierGraph(supplierResult, costResult)
                })
        },

        async initiateSupplierGraph(supplierData, costData) {
            this.stockOrderHistory = {
                    labels: await supplierData.map(x => x.supplierOrganisation.name),
                    datasets: [{
                        label: 'Orders',
                        data: await supplierData.map(x => x.total),
                        backgroundColor: 'rgba(74, 168, 50, 0.2)',
                        borderColor: 'rgba(74, 168, 50, 1)',
                        borderWidth: 1
                    }]
                },
                this.stockOrderHistoryOptions = {

                    title: {
                        display: true,
                        text: 'Orders Per Supplier'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            this.priceMovement = {
                    labels: await costData.map(x => x.group),
                    datasets: [{
                        label: 'Price Movement',
                        data: await costData.map(x => x.averagePrice),
                        backgroundColor: 'rgba(58, 50, 168, 0.2)',
                        borderColor: 'rgba(58, 50, 168, 1)',
                        borderWidth: 1
                    }]
                },
                this.priceMovementOptions = {

                    title: {
                        display: true,
                        text: 'Average Price per Unit (ZAR)'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            this.supplierDataLoaded = true
        },
    }
}
</script>
